<script setup lang="ts">
import { computed } from "vue";
import { UiAvatar, UiButton, UiText, generateInitials } from "@shopexperts/shared";

const props = defineProps<{
  name: string;
  email?: string | null;
  role?: string | null;
  avatar?: string | null;
  bordered?: boolean;
  removable?: boolean;
}>();

const emit = defineEmits<{
  remove: [];
}>();

const initials = computed(() => generateInitials(props.name || "Expert"));
</script>

<template>
  <div
    class="rounded-xl bg-white p-4"
    :class="bordered ? 'border border-gray-200' : 'border border-gray-100'"
  >
    <div class="flex items-start gap-3">
      <UiAvatar
        :name="name"
        :url="avatar ?? undefined"
        :initials="initials"
        size="xs"
        :responsive="false"
        color-coded
      />

      <div class="min-w-0 flex-1">
        <UiText as="p" variant="p" class="font-semibold text-gray-900 truncate">
          {{ name }}
        </UiText>
        <UiText v-if="role" as="p" variant="p-small" class="mt-0.5 text-gray-600">
          {{ role }}
        </UiText>
        <UiText v-if="email" as="p" variant="p-small" class="mt-0.5 text-gray-500 truncate">
          {{ email }}
        </UiText>
      </div>

      <UiButton
        v-if="removable"
        variant="ghost"
        label="Remove"
        @click="emit('remove')"
      />
    </div>
  </div>
</template>
